/* eslint-disable react/prop-types */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var DownloadIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b, _c = _a.color, color = _c === void 0 ? '#525865' : _c, _d = _a.strokeWidth, strokeWidth = _d === void 0 ? 2 : _d, _e = _a.styles, styles = _e === void 0 ? {} : _e;
    return (React.createElement("svg", { style: __assign({ width: size }, styles), xmlns: "http://www.w3.org/2000/svg", version: "1.1", viewBox: "0 0 24 24", height: "24", width: "24" },
        React.createElement("title", null, "check double (From Streamline App : https://app.streamlineicons.com)"),
        React.createElement("g", { transform: "matrix(1,0,0,1,0,0)" },
            React.createElement("path", { d: "M 12.001,3.75v12 ", stroke: color, fill: "none", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }),
            React.createElement("path", { d: "M 7.501,11.25l4.5,4.5l4.5-4.5 ", stroke: color, fill: "none", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }),
            React.createElement("path", { d: "M 23.251,15.75v1.5c0,1.657-1.343,3-3,3h-16.5 c-1.657,0-3-1.343-3-3v-1.5", stroke: color, fill: "none", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }))));
};
export default DownloadIcon;
